import { SxProps, Theme } from '@mui/material'

export const containerSx: SxProps<Theme> = {
  padding: {
    xs: '1.6rem 2.4rem',
    lg: '2.8rem 3.2rem',
    xl: '2.8rem 4.8rem',
  },
  gap: {
    xs: '1.6rem',
    md: '2.4rem',
  },
  backgroundColor: (theme) => theme.palette.background.default,
  alignItems: 'center',
  borderTop: (theme) => `0.1rem solid ${theme.palette.divider}`,
  borderBottom: (theme) => `0.1rem solid ${theme.palette.divider}`,
}
